<div class="panel-body">

	<!-- CREATE BUTTONS -->
	<div class="row">
	
		<div class="col-sm-8">
			<input [(ngModel)]="mButtonName" type="text" placeholder="Button Name" style="color: #ffffff" class="form-control" />
		</div>
		
		<div class="col-sm-4">
			<button (click)="addButtonClicked()" type="button" class="btn btn-primary" tabindex="-1">
				<ng-container *ngIf="mSelectedButton == null">
					<i class="fa fa-plus"></i>
					ADD
				</ng-container>
				<ng-container *ngIf="mSelectedButton != null">
					UPDATE
				</ng-container>
			</button>
		</div>
	</div>
	
	<div class="row">
		<div class="input-group" style="padding-top: 10px; padding-bottom: 10px; max-width:100%;">
			<div class="col-sm-12">
				<div class="input-group-btn" style="overflow: hidden; align: center; width: 100%">
					<button (click)="mButtonColorUi = mButtonColors.WHITE" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.WHITE"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.BLACK" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-default">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.BLACK"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.ORANGE" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-primary">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.ORANGE"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.GREEN" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-success">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.GREEN"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.BLUE" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-info">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.BLUE"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.YELLOW" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-warning">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.YELLOW"></i>
						&nbsp;
					</button>
					<button (click)="mButtonColorUi = mButtonColors.RED" type="button" style="height: 30px; margin-left: 2px; padding: 0px; width: 30px" class="btn btn-danger">
						<i class="fa fa-check" *ngIf="mButtonColorUi == mButtonColors.RED"></i>
						&nbsp;
					</button>
				</div>
			</div>
		</div>
	</div>
	
	<div class="row">
		<div class="col-sm-8">
			<div class="input-group-btn">
				<span class="dropdown">
					<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{{mButtonTypeUi}}
						<span class="caret"></span>
					</button>
					<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto">
						<li (click)="mButtonTypeUi = mButtonTypes.NORMAL">
							<a class="ef">
								{{mButtonTypes.NORMAL}}
							</a>
						</li>
						<li (click)="mButtonTypeUi = mButtonTypes.OWNER">
							<a class="ef">
								<i class="fa fa-check"></i>
								{{mButtonTypes.OWNER}}
							</a>
						</li>
						<li (click)="mButtonTypeUi = mButtonTypes.CLOSE">
							<a class="ef">
								<i class="fa fa-close"></i>
								{{mButtonTypes.CLOSE}}
							</a>
						</li>
						<li (click)="mButtonTypeUi = mButtonTypes.DECLINE">
							<a class="ef">
								<i class="fa fa-exclamation-circle"></i>
								{{mButtonTypes.DECLINE}}
							</a>
						</li>
					</ul>
				</span>
			</div>
		</div>
		
		<div class="col-sm-4">
			<button (click)="mIsWait = !mIsWait" type="button" class="btn" [class.btn-primary]="mIsWait" [class.btn-default]="!mIsWait">
				<i *ngIf="mIsWait" class="fa fa-check"></i>
				<i class="fa fa-hourglass-2"></i>
				WAIT
			</button>
		</div>
	</div>
	
</div>